import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import 'src/pages/project/styles/Search.less';

import SearchContent from 'src/components/project/search/Content';
import { useConciergeContextState } from 'src/components/concierge/ConciergeContext';

function ProjectQuotes() {
  const { projectId } = useParams();
  const [filters, setFilters] = useConciergeContextState([
    'explore',
    'filters'
  ]);
  useEffect(
    () =>
      setFilters((v) => ({
        ...(v || {}),
        project: { id: projectId, use_filters: true }
      })),
    []
  );
  return (
    <div className="search-page">
      <div className="content search-content">
        <SearchContent pageSize={100} />
      </div>
    </div>
  );
}

export default ProjectQuotes;
